"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PreQualifiersFields = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _HeightWeight = _interopRequireDefault(require("../HeightWeight/HeightWeight"));

var _Qualifier = _interopRequireDefault(require("./Qualifier/Qualifier"));

var _preQualifiersConfig = require("./preQualifiersConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

// eslint-disable-next-line import/no-cycle
var PreQualifiersDefinition = _flowRuntime["default"].tdz(function () {
  return _preQualifiersConfig.PreQualifiersDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string()), _flowRuntime["default"].property("preQualifiers", _flowRuntime["default"].ref(PreQualifiersDefinition)), _flowRuntime["default"].property("ageTrue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("ukTrue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("hivTrue", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("drugsTrue", _flowRuntime["default"]["boolean"]())));

var PreQualifiersFields = function PreQualifiersFields(_arg) {
  var ageTrue = _arg.ageTrue,
      componentKey = _arg.componentKey,
      drugsTrue = _arg.drugsTrue,
      hivTrue = _arg.hivTrue,
      preQualifiers = _arg.preQualifiers,
      ukTrue = _arg.ukTrue;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, preQualifiers.options.age && /*#__PURE__*/_react["default"].createElement(_Qualifier["default"], {
    parentKey: componentKey,
    qualifier: _preQualifiersConfig.age
  }), preQualifiers.options.liveInUk && ageTrue && /*#__PURE__*/_react["default"].createElement(_Qualifier["default"], {
    parentKey: componentKey,
    qualifier: _preQualifiersConfig.liveInUk
  }), preQualifiers.options.heightWeight && ukTrue && /*#__PURE__*/_react["default"].createElement(_HeightWeight["default"], {
    heightWeight: _preQualifiersConfig.heightWeight,
    parentKey: componentKey
  }), preQualifiers.options.hiv && /*#__PURE__*/_react["default"].createElement(_Qualifier["default"], {
    parentKey: componentKey,
    qualifier: _preQualifiersConfig.hiv
  }), preQualifiers.options.drugs && !hivTrue && hivTrue !== undefined && /*#__PURE__*/_react["default"].createElement(_Qualifier["default"], {
    parentKey: componentKey,
    qualifier: _preQualifiersConfig.drugs
  }), preQualifiers.options.medicalConditions && !drugsTrue && drugsTrue !== undefined && /*#__PURE__*/_react["default"].createElement(_Qualifier["default"], {
    parentKey: componentKey,
    qualifier: _preQualifiersConfig.medicalConditions
  }));
};

exports.PreQualifiersFields = PreQualifiersFields;
var selector = (0, _reduxForm.formValueSelector)('form');

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var key = ownProps.preQualifiers.key;
  return {
    ageTrue: selector(state, "".concat(key, ".age")),
    ukTrue: selector(state, "".concat(key, ".liveInUk")),
    hivTrue: selector(state, "".concat(key, ".hiv")),
    drugsTrue: selector(state, "".concat(key, ".drugs"))
  };
}; // $FlowFixMe WEB-352


var _default = (0, _reactRedux.connect)(mapStateToProps)(PreQualifiersFields);

exports["default"] = _default;